// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ISequenceOrderDto } from './ISequenceOrderDto';
import {
    ISequenceOrderDtoFromJSON,
    ISequenceOrderDtoFromJSONTyped,
    ISequenceOrderDtoToJSON,
    ISequenceOrderDtoToJSONTyped,
} from './ISequenceOrderDto';

/**
 * 
 * @export
 * @interface IAllowedServiceDto
 */
export interface IAllowedServiceDto {
    /**
     * 
     * @type {number}
     * @memberof IAllowedServiceDto
     */
    service_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IAllowedServiceDto
     */
    sequence_id?: number;
    /**
     * 
     * @type {Set<ISequenceOrderDto>}
     * @memberof IAllowedServiceDto
     */
    plans?: Set<ISequenceOrderDto>;
}

/**
 * Check if a given object implements the IAllowedServiceDto interface.
 */
export function instanceOfIAllowedServiceDto(value: object): value is IAllowedServiceDto {
    return true;
}

export function IAllowedServiceDtoFromJSON(json: any): IAllowedServiceDto {
    return IAllowedServiceDtoFromJSONTyped(json, false);
}

export function IAllowedServiceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAllowedServiceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'service_id': json['service_id'] == null ? undefined : json['service_id'],
        'sequence_id': json['sequence_id'] == null ? undefined : json['sequence_id'],
        'plans': json['plans'] == null ? undefined : (new Set((json['plans'] as Array<any>).map(ISequenceOrderDtoFromJSON))),
    };
}

export function IAllowedServiceDtoToJSON(json: any): IAllowedServiceDto {
    return IAllowedServiceDtoToJSONTyped(json, false);
}

export function IAllowedServiceDtoToJSONTyped(value?: IAllowedServiceDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'service_id': value['service_id'],
        'sequence_id': value['sequence_id'],
        'plans': value['plans'] == null ? undefined : (Array.from(value['plans'] as Set<any>).map(ISequenceOrderDtoToJSON)),
    };
}

